// @flow
import ga from './../../vendor/google-analytics';

export function event(action: string): string => void {
  return function(label): void {
    ga('send', 'event', 'HomepageRows', action, label);
  }
}